// extracted by mini-css-extract-plugin
export default {"container":"_f609443e","icon":"_96f455b2"};